import React from 'react';
import PaymentTypeStaticSelectProperties from "./PaymentTypeStaticSelectProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import SelectOption from "../../../ui_components/Select/SelectOption";
import CreditCardIcon from '@mui/icons-material/CreditCard';
import Select from "../../../ui_components/Select/Select";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PaymentType from '../../../entities/PaymentType';
import CashPaymentIcon from '../../../ui_components/Icon/icons/CashPaymentIcon';
import CheckPaymentIcon from '../../../ui_components/Icon/icons/CheckPaymentIcon';
import WireTransferIcon from '../../../ui_components/Icon/icons/WireTransferIcon';
import ZelleIcon from '../../../ui_components/Icon/icons/ZelleIcon';
import CreditCardSharpIcon from '@mui/icons-material/CreditCardSharp';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';

const PaymentTypeStaticSelect: React.FC<PaymentTypeStaticSelectProperties> = ({
                                                                        selected,
                                                                        options,
                                                                        label = '',
                                                                        hint,
                                                                        onChange,
                                                                        disabled,
                                                                        fullWidth = false,
                                                                        className = '',
                                                                        error
                                                                    }) => {

    const i18n = useI18nContext();

    const getIcon = (paymentType: PaymentType) => {
        switch (paymentType) {
            case PaymentType.CASH:
                return CashPaymentIcon;
            case PaymentType.CHECK:
                return CheckPaymentIcon;
            case PaymentType.CREDIT:
                return CreditCardIcon;
            case PaymentType.DEBIT:
                return CreditCardSharpIcon;
            case PaymentType.WIRE_TRANSFER:
                return WireTransferIcon;
            case PaymentType.ZELLE:
            case PaymentType.ZELLE_LOWER:
            case PaymentType.ZELLE_EXTRA:
            case PaymentType.ZELLE_ARTICLE_HIGH:
                return ZelleIcon;
            case PaymentType.DISTANCE:
            case PaymentType.DISTANCE_LOWER:
            case PaymentType.CREDIT_DISTANCE:
            case PaymentType.DEBIT_DISTANCE:
                return PermPhoneMsgIcon;
        }
    }

    const finalOptions = options || Object.values(PaymentType) as PaymentType[];
    const opt = finalOptions.map(p => {
        return new SelectOption(i18n.translate(`PAYMENT_TYPE_${p}`), p, '', getIcon(p));
    })

    const selectedOption = opt.find(t => t.value === selected);

    const onStatusChange = (option: SelectOption) => {
        onChange(option.value as PaymentType)
    }

    return (
        <Select
            error={error}
            className={className}
            disabled={disabled}
            fullWidth={fullWidth}
            label={label && label !== '' ? label : "Tipo"}
            placeholder={"Seleccione"}
            hint={hint}
            selected={selectedOption}
            icon={AttachMoneyIcon}
            onChange={onStatusChange}
            elements={opt}
        />
    )
}


export default PaymentTypeStaticSelect;